.base {
  transform-origin: center;
  position: absolute;
  top: -15px;
  border-radius: var(--mantine-radius-md) var(--mantine-radius-md) 0 0;
  width: 300px;
}

.left {
  rotate: -90deg;
  right: -148px;
}

.right {
  rotate: 90deg;
  left: -164px;
}
